import { render } from "./NavbarMain.vue?vue&type=template&id=09223e10"
import script from "./NavbarMain.vue?vue&type=script&lang=js"
export * from "./NavbarMain.vue?vue&type=script&lang=js"

import "./NavbarMain.vue?vue&type=style&index=0&id=09223e10&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__